import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { spotFinder } from './endpoints';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';

// Define a service using a base URL and expected endpoints
export const vehicleCategoryApi = createApi({
  reducerPath: 'vehicleCategoryApi',
  baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
  tagTypes: ['vehicleCategory'],
  endpoints: (builder) => ({
    
    getCategoryList: builder.mutation({
      query(body) {
        return {
          url: spotFinder.VehicleCategoryController.getCategoryList,
          method: 'GET',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
   
    getSubCategoryList: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.VehicleCategoryController.getSubCategoryList}${body.categoryId}`,
          method: 'GET',
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
  }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetCategoryListMutation , useGetSubCategoryListMutation
} = vehicleCategoryApi;
